export const VENDOR_PRODUCTS_RESET_STATE = 'VENDOR_PRODUCTS_RESET_STATE';
export const VENDOR_PRODUCTS_CURRENT_ITEM = 'VENDOR_PRODUCTS_CURRENT_ITEM';

export const VENDOR_PRODUCTS_REQUEST_LOADING = 'VENDOR_PRODUCTS_REQUEST_LOADING';
export const VENDOR_PRODUCTS_REQUEST_SUCCESS = 'VENDOR_PRODUCTS_REQUEST_SUCCESS';
export const VENDOR_PRODUCTS_REQUEST_FAILED = 'VENDOR_PRODUCTS_REQUEST_FAILED';

export const VENDOR_PRODUCTS_CURRENT_ACTION = 'VENDOR_PRODUCTS_CURRENT_ACTION';
export const VENDOR_PRODUCTS_RESET_ACTION = 'VENDOR_PRODUCTS_RESET_ACTION';
